import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import vue2Dropzone from "vue2-dropzone";
import Multiselect from "vue-multiselect";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { PMOProjectModel } from "@/store/models/project/PMOProject";
import { toaster } from "@/utilities/toaster";
import { ProjectModule } from "@/store/modules/project.module";
Component.registerHooks(["metaInfo"]);
let CreateNewProject = /** @class */ (() => {
    let CreateNewProject = class CreateNewProject extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Create New Project";
            this.newProject = new PMOProjectModel();
            this.pageIsLoading = true;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Projects",
                    to: "/projects",
                },
                {
                    text: "Add Project",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    text: "Projects",
                    routeName: "Projects",
                    cssClasses: "btn btn-sm btn-primary",
                },
            ];
        }
        // private dpvalue: null;
        // private value: null;
        // private options: any = ["Titus", "Arun George", "Naanchy", "Anisha"];
        saveProject() {
            this.validate("createProjectObserver").then((response) => {
                if (response) {
                    ProjectModule.CreateProject(this.newProject).then((response) => {
                        if (response) {
                            toaster.ShowSuccess("Project was created successfully.");
                            this.$router.push({ name: "Projects" });
                        }
                    });
                }
            });
        }
        // private dpvalue: null
        // private value: null
        // private options: any = [
        //     "Titus",
        //     "Arun George",
        //     "Naanchy",
        //     "Anisha"
        // ]
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
    };
    CreateNewProject = __decorate([
        Component({
            name: "CreateNewProject",
            components: {
                Loader,
                Layout,
                PageHeader,
                Multiselect,
                vueDropzone: vue2Dropzone,
            },
        })
    ], CreateNewProject);
    return CreateNewProject;
})();
export default CreateNewProject;
